export default __webpack_public_path__ + "static/media/tavi_mobile@2x.ac15ab6f.jpg";